var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoBall = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_sport_status",
    d: "M270.623,18a9,9,0,1,0-9-9A8.98,8.98,0,0,0,270.623,18Zm8.112-8.207.012.01a8.078,8.078,0,0,1-.6,2.374q-.156.369-.346.719l-.017,0-2.351.35-.915.136-1.507-1.963-.04-.052.982-3.022,2.368-.778Zm-7.694-6.655,2.86-1.6.014-.009a8.137,8.137,0,0,1,2.48,1.7q.156.157.3.32s0,.009,0,.014l-.631,3.209-2.448.8-2.574-1.87V3.139ZM272.394,12l1.474,1.921-1.273,2.993-.006.016a8.234,8.234,0,0,1-3.932,0l-.006-.016-1.273-2.993L268.852,12Zm-7.543-8.767a8.137,8.137,0,0,1,2.48-1.7l.014.009,2.86,1.6V5.706l-2.431,1.766-.143.1-2.448-.8L264.892,5.3l-.341-1.737,0-.014Q264.695,3.385,264.851,3.228Zm-1.4,9.668q-.19-.35-.347-.719a8.08,8.08,0,0,1-.6-2.374l.012-.01,2.417-2.224,2.368.778.982,3.022-1.546,2.015-3.267-.486Z",
    transform: "translate(-261.623)",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoBall);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_ball.41e76dfc57086252b7c6989a856a48c2.svg";